import { useMemo } from 'react'
import React from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'

import { PatientSurvey } from '../../api/services/surveys/types.ts'
import {
  setPatientSurveysTableActions,
  setPatientSurveysTableColumns
} from '../../utils/patientSurveys/patientSurveysTableSettings.tsx'
import Alert from '../common/Alert/Alert.tsx'
import Card from '../common/Card/Card.tsx'
import Table from '../common/Table/Table.tsx'

const PatientSurveys = ({ surveys, patientProfileId, patientFullName }: { surveys: PatientSurvey[], patientProfileId: number, patientFullName: string }) => {
  const navigate = useNavigate()
  const columns = useMemo(() => setPatientSurveysTableColumns(), [])
  const actions = useMemo(() => setPatientSurveysTableActions(navigate, patientProfileId, patientFullName), [])

  return (
    <React.Fragment>
      <Card.Title>
        <div className="h-10 flex flex-row justify-between items-center">
          <span className="mr-3">Ankiety pacjenta</span>
        </div>
      </Card.Title>

      <Card.Body>
        {surveys && (
          <>
            <Table data={surveys} columns={columns} actions={actions} />
          </>
        )}

        {surveys && surveys.length === 0 && (
          <div>
            <Alert
              type="info"
              message="Brak danych"
              icon={<AiOutlineInfoCircle className="text-lg" />}
            />
          </div>
        )}
      </Card.Body>
    </React.Fragment>
  )
}

export default PatientSurveys
